import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import { WOW } from 'wowjs'
import '../node_modules/wowjs/css/libs/animate.css'
Vue.prototype.$wow = WOW;

// 將 /index.html 轉址到 /，避免 Google 收錄重複頁面
if (window.location.pathname === '/index.html') {
  window.location.replace('/')
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
